import { render, staticRenderFns } from "./DispatchMailListTable.vue?vue&type=template&id=6e0794e8&scoped=true&lang=pug"
import script from "./DispatchMailListTable.vue?vue&type=script&lang=js"
export * from "./DispatchMailListTable.vue?vue&type=script&lang=js"
import style0 from "./DispatchMailListTable.vue?vue&type=style&index=0&id=6e0794e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0794e8",
  null
  
)

export default component.exports